// removed by extract-text-webpack-plugin
module.exports = {"loader__wrapper":"pcd5l","loader":"dMe7E","loadingAnimation":"_2y3Bt"};


//////////////////
// WEBPACK FOOTER
// ./components/GenericStatusLoading/styles.scss
// module id = 608
// module chunks = 0